export const ACCOUNT_TYPES = {
  ENTITY: 'ENTITY' as const,
  CURRENCY: 'CURRENCY' as const,
  EXPENSE_ENTITY: 'EXPENSE_ENTITY' as const,
};
export type AccountTypes = keyof typeof ACCOUNT_TYPES;
